const types = {
    SET_LIST_MESSANGER: '[MESSANGER] SET LIST MESSANGER',
    SET_VIEW_MESSANGER: '[MESSANGER] SET VIEW MESSANGER'
}

export {
    types
}